import { Avatar, Tooltip } from "@mui/material";
import React, { useState, useEffect } from "react";
import { getAvatarColor, getInitials } from "../utilities/avatarColors";

// The tint only ever shows through when the image is absent or fails to load,
// so it is applied unconditionally rather than branching on `src`.
const getAvatarProps = (name, style) => {
    const initials = getInitials(name);
    const { bg, fg } = getAvatarColor(name);
    return {
        sx: {
            bgcolor: bg,
            color: fg,
            width: "2.5rem",
            height: "2.5rem",
            fontSize: "1rem",
            fontWeight: 500,
            borderRadius: "50%",
            cursor: "pointer",
            position: "relative",
            ...style
        },
        children: initials,
    };
};

function ImageAvatar({ src, alt, width = "2.5rem", height = "2.5rem", style, tooltip = false, toolTipPlacement = "bottom", updatedDate = null }) {

    return (
        <div style={{ position: "relative", display: "inline-block", width, height }}>
            {/* Avatar Background (Always Visible) */}
            {(tooltip ? (
                <Tooltip title={alt} placement={toolTipPlacement}>
                    <Avatar src={src + (updatedDate ? `?cacheBuster=${updatedDate}` : "")} {...getAvatarProps(alt, style)} />
                </Tooltip>
            ) : (
                <Avatar src={src + (updatedDate ? `?cacheBuster=${updatedDate}`: "")} {...getAvatarProps(alt,style)} />
            ))}
        </div>
    );
}

export default ImageAvatar;
